import React, { ChangeEvent, FC } from "react";
import classNames from "classnames";

import { Input } from "@/components/common";
import { detailInputsList, detailInputsListUK } from "../../utils";
import { TDetailInputsProps } from "../types";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";

const DetailInputs: FC<TDetailInputsProps> = ({
  inputValues,
  handleChange,
  isModal,
}) => {
  const theme = useTheme();

  const inputList = theme === Theme.UK ? detailInputsListUK : detailInputsList;

  return (
    <div className="relative flex gap-2">
      {inputList.map((input, index) => {
        return (
          <Input
            key={input.value}
            labelClassName="!left-[17%]"
            label={input.label}
            className={classNames(
              "h-[3.87rem] w-full rounded-none !bg-[#f1f6f7] text-sm focus:outline-none",
              {
                "rounded-bl-[31px] rounded-tl-[31px]": index === 0,
                "rounded-br-[31px] rounded-tr-[31px]":
                  index === 4 || index === inputList.length - 1,
                "max-w-[120px]": !isModal,
              },
            )}
            value={inputValues[input.value] || ""}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              handleChange(input.value, event.target.value);
            }}
          />
        );
      })}
    </div>
  );
};

export { DetailInputs };
